import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from "@angular/router";

export class CustomRouteReuseStrategy extends RouteReuseStrategy {
    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }
    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {}
    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }
    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
        return null;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        let shouldReuse = false;
        if (curr.data.reUse) {
            shouldReuse = true;
        }

        return shouldReuse;
        // return (future.routeConfig === curr.routeConfig && (curr.queryParamMap.get("id") === future.queryParamMap.get("id"))) || shouldReuse; DW-268 => we want to reuse nothing
    }
}
